import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import Axios from "axios";
import { ActiveFilter } from "features/Filters/types";
import { API_URL } from "config";
import { activeFiltersToURLParams } from "features/utils";
import { setFilters } from "features/Filters/filtersSlice";
import { SortingType } from "pages/category/types";
import { batch } from "react-redux";

import {
  setTotalItems,
  setTotalPages,
} from "features/pagination/paginationSlice";
interface SearchState {
  searchedProducts: any[];
  searchedProductsForPage: any[];
  isSearching: boolean;
  isLoading: boolean;

  activeSortingType: SortingType;
}

const initialState: SearchState = {
  activeSortingType: SortingType.priceasc,
  searchedProducts: [],
  searchedProductsForPage: [],
  isSearching: false,
  isLoading: false,
};

const search = createSlice({
  name: "search",
  initialState,
  reducers: {
    setActiveSortingType(state, action) {
      state.activeSortingType = action.payload;
    },
    setSearchedProducts(state, action) {
      state.searchedProducts = action.payload;
      state.isSearching = false;
    },
    setSearchedProductsForPage(state, action) {
      state.searchedProductsForPage = action.payload;
      state.isLoading = false;
    },
    setSearching(state, action) {
      state.isSearching = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setActiveSortingType,
  setSearchedProducts,
  setSearching,
  setSearchedProductsForPage,
  setLoading,
} = search.actions;

export default search.reducer;

export const fetchSearchedProducts =
  (
    filters: ActiveFilter[],
    page: number = 1,
    activeCategorySortingType: string = SortingType.none,
    isFromSearchBar = false
  ) =>
  async (dispatch: any) => {
    isFromSearchBar ? dispatch(setSearching(true)) : dispatch(setLoading(true));

    try {
      const filtersAsParams = activeFiltersToURLParams(filters);

      const sort =
        activeCategorySortingType &&
        `${activeCategorySortingType
          .split(",")
          .map((item) => `&sort=${item}`)
          .join("&")}`;
      const result = await Axios.get(
        `${API_URL}/search?size=12&page=${page}${filtersAsParams}${sort}`
      );

      batch(() => {
        isFromSearchBar
          ? dispatch(setSearchedProducts(result.data.data))
          : dispatch(setSearchedProductsForPage(result.data.data));

        // dispatch(setFilters(result.data.filters));
        dispatch(setTotalPages(result.data.pages));
        dispatch(setTotalItems(result.data.filteredCout));
      });
    } catch (error: any) {
      console.log(
        `Error in categorySlice fetchFilteredProducts: ${error.message}`
      );
    }
  };

export const searchSelectors = {
  searchResult: (state: RootState) => state.search.searchedProducts,
  searchResultForPage: (state: RootState) =>
    state.search.searchedProductsForPage,
  selectSearching: (state: RootState) => state.search.isSearching,
  selectLoading: (state: RootState) => state.search.isLoading,

  selectActiveSortingType: (state: RootState) => state.search.activeSortingType,
};
